/* DDV · Switch Giorno / Notte sulle griglie prodotti (18/10/2026)
   Mette il pulsante Accendi/Spegni su ogni griglia di card prodotto e ricorda la scelta del visitatore.
   In fondo: dissolvenza sulla foto grande delle sezioni "Prodotto in evidenza".
   In "Notte" la sezione diventa scura e le card mostrano la seconda foto (candela accesa).
   Per toglierlo: cancellare la riga render 'ddv-giorno-notte' in fondo a snippets/meta-tags.liquid. */
(function () {
  var KEY = 'ddv-gn';
  var root = document.documentElement;

  function leggi() { try { return localStorage.getItem(KEY) === 'notte' ? 'notte' : 'giorno'; } catch (e) { return 'giorno'; } }
  function salva(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }

  function applica(v) {
    var notte = v === 'notte';
    root.classList.toggle('ddv-notte', notte);
    document.querySelectorAll('.ddv-gn__btn').forEach(function (b) {
      b.setAttribute('aria-pressed', notte ? 'true' : 'false');
      b.setAttribute('aria-label', notte ? 'Spegni le candele: torna alla vista giorno' : 'Accendi le candele: passa alla vista notte');
      var t = b.querySelector('.ddv-gn__txt');
      var testo = notte ? 'Spegni' : 'Accendi';
      if (t && t.textContent !== testo) t.textContent = testo; /* solo se cambia, così l'osservatore qui sotto non gira a vuoto */
    });
  }

  /* Fiammella semplice: di giorno solo il contorno, di notte si accende (riempimento arancione) */
  var FIAMMA = '<svg class="ddv-gn__fiamma" viewBox="0 0 16 20" aria-hidden="true" focusable="false">' +
    '<path d="M8.4 1C8.9 3.4 13.2 6 13.2 10.9A5.2 5.2 0 0 1 2.8 10.9C2.8 8.2 4.4 6.5 5.8 5.1C5.9 6.4 6.4 7.3 7.1 7.8C6.8 5.4 7.2 3 8.4 1Z" stroke-width="1.1" stroke-linejoin="round"/></svg>';

  function crea() {
    var box = document.createElement('div');
    box.className = 'ddv-gn';
    box.innerHTML = '<button type="button" class="ddv-gn__btn" aria-pressed="false">' + FIAMMA + '<span class="ddv-gn__txt">Accendi</span></button>';
    box.querySelector('button').addEventListener('click', function () {
      var v = root.classList.contains('ddv-notte') ? 'giorno' : 'notte';
      salva(v);
      applica(v);
    });
    return box;
  }

  /* Trova ogni griglia di card prodotto e ci mette il pulsante (uno per sezione).
     Nelle collezioni va a destra, accanto a "Filtra"; altrove sopra la griglia, a destra. */
  function monta() {
    document.querySelectorAll('.product-card-wrapper').forEach(function (card) {
      var lista = card.closest('ul');
      var sez = card.closest('.shopify-section');
      if (!lista || !sez || sez.querySelector('.ddv-gn')) return;
      var box = crea();
      var filtri = sez.querySelector('.facets-container');
      if (filtri) {
        box.classList.add('ddv-gn--filtri');
        filtri.appendChild(box);
        misuraFiltra();
      } else {
        var punto = lista.closest('slider-component') || lista;
        if (!punto.parentElement.closest('.page-width')) box.classList.add('page-width');
        punto.parentElement.insertBefore(box, punto);
      }
    });
    dissolvenzaInEvidenza();
    applica(leggi());
  }

  /* Misura il tasto "Filtra" per mettere Accendi/Spegni subito alla sua sinistra (computer) */
  function misuraFiltra() {
    document.querySelectorAll('.ddv-gn--filtri').forEach(function (box) {
      var f = box.parentElement.querySelector('.mobile-facets__open-wrapper');
      var w = f ? f.getBoundingClientRect().width : 0;
      if (w > 0) box.style.setProperty('--ddv-filtra-w', Math.round(w) + 'px');
    });
  }
  window.addEventListener('resize', function () { clearTimeout(misuraFiltra.t); misuraFiltra.t = setTimeout(misuraFiltra, 150); });

  /* PRODOTTO IN EVIDENZA: al passaggio del mouse sulla foto grande appare in dissolvenza la seconda foto (solo computer) */
  function dissolvenzaInEvidenza() {
    document.querySelectorAll('.section-featured-product media-gallery').forEach(function (g) {
      if (g.querySelector('.ddv-fp-hover')) return;
      var slide = g.querySelectorAll('.product__media-list > li');
      if (slide.length < 2) return;
      var prima = slide[0].querySelector('.product__media img');
      var seconda = slide[1].querySelector('.product__media img');
      if (!prima || !seconda) return;
      var copia = document.createElement('img');
      copia.className = 'ddv-fp-hover';
      copia.alt = '';
      copia.setAttribute('aria-hidden', 'true');
      copia.loading = 'lazy';
      if (seconda.getAttribute('sizes')) copia.sizes = seconda.getAttribute('sizes');
      if (seconda.getAttribute('srcset')) copia.srcset = seconda.getAttribute('srcset');
      copia.src = seconda.getAttribute('src');
      copia.style.objectFit = getComputedStyle(prima).objectFit || 'cover';
      prima.parentElement.appendChild(copia);
    });
  }

  var attesa;
  function rimonta() { clearTimeout(attesa); attesa = setTimeout(monta, 120); }

  applica(leggi());
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', monta); else monta();
  /* Filtri della collezione, pagine successive ed editor del tema ricaricano le griglie: rimetto il pulsante */
  document.addEventListener('shopify:section:load', rimonta);
  if ('MutationObserver' in window) {
    new MutationObserver(function (m) {
      for (var i = 0; i < m.length; i++) { if (m[i].addedNodes.length) { rimonta(); return; } }
    }).observe(document.body || root, { childList: true, subtree: true });
  }
})();
